import {Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useTranslation} from 'hooks';
import {FC, useCallback, useMemo} from 'react';
import {ISearchAutocompleteItem, ProviderTypeEnum} from 'types';
import ImageUI from 'ui/ImageUI';

interface Props {
  onClick: (item: ISearchAutocompleteItem) => void;
  item: ISearchAutocompleteItem;
  selected: boolean;
}

export const SearchResultItem: FC<Props> = ({onClick, item, selected}) => {
  const {t} = useTranslation();
  const description = useMemo(() => {
    if (item?.type === 'category') {
      return t('CATEGORY');
    } else if (item?.type === 'provider') {
      return t(item.provider_type === ProviderTypeEnum.RESTAURANT ? 'RESTAURANT' : 'MARKET');
    }
  }, [item, t]);

  const handleClick = useCallback(() => {
    onClick(item);
  }, [onClick, item]);

  return (
    <Flex
      _hover={{bg: colors.lightGray}}
      sx={selected ? {bg: colors.lightGray} : {}}
      borderRadius="1rem"
      cursor="pointer"
      alignItems="center"
      p="10px 15px"
      onClick={handleClick}
    >
      <ImageUI w="16px" h="16px" mr="15px" src="/icons/search.svg" alt="find" />
      <Flex flexDirection="column">
        <Text fontWeight={600} fontSize="1rem" color={colors.black}>
          {item.name}
        </Text>
        {description && (
          <Text fontWeight={500} opacity="0.5" fontSize="14px" color={colors.lightBlack}>
            {description}
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
